export const EXTERNAL_EVIDENCE_SOURCE_TYPE = {
    'CREDENTIAL_ENGINE': 'EXTERNAL_EVIDENCE_CREDENTIAL_ENGINE',
    'CUSTOM': 'EXTERNAL_EVIDENCE_CUSTOM'
};
